/**
 * ELLE YEDEK ÖZETİ (gelen karar 02.11.2026;
 * `claude/notlar/2026-11-02-kalici-depolama-uyarisi-kararlar.md`).
 *
 * Ayarlar'daki "Yedeğinizi almadan veri girmeyin" uyarısı, şifreli yedek
 * (.pfai) elle alındıysa gizlenir; kasa o yedekten sonra değişince yeniden
 * görünür. Bunun için son elle yedekteki kasanın özeti KASANIN KENDİ
 * ayarlarında (şifreli kapta) tutulur — profil dışında yedek durumu
 * saklanmaz (CLAUDE.md §8).
 *
 * Özet: kayıtlar + ayarlar, ŞU ayarlar hariç: bu özetin kendisi ve
 * kendiliğinden değişen ayarlar (abonelik teyidi, Dönemsel Getiri görünüm
 * tercihi). Bilinmeyen bir ayar dahil kalır: hata yönü "uyarı yeniden
 * görünür" olsun, "yedeksiz değişiklik gizlenir" değil.
 */

import { SON_TEYIT_AYARI } from "../kabiliyet/kabiliyet";
import { DONEMSEL_TERCIH_ANAHTARI } from "./donemselTercih";
import { ELLE_YEDEK_AYARI, OTO_INDIR_AYARI, OTO_INDIR_BEKLEME_AYARI, SON_INDIRME_AYARI } from "./yedekAyarlari";

export { ELLE_YEDEK_AYARI };

// Otomatik indirmenin kendi ayarları da girmez: indirme kaydı yazılınca ya da
// anahtar değişince "yedekten beri değişti" sayılmasın.
const OZETE_GIRMEYEN_AYARLAR: ReadonlySet<string> = new Set([
  ELLE_YEDEK_AYARI,
  SON_INDIRME_AYARI,
  OTO_INDIR_AYARI,
  OTO_INDIR_BEKLEME_AYARI,
  SON_TEYIT_AYARI,
  DONEMSEL_TERCIH_ANAHTARI,
]);

export async function elleYedekOzeti(json: string): Promise<string> {
  const nesne = JSON.parse(json) as Record<string, unknown>;
  delete nesne["exportedAt"];
  const ayarlar = nesne["settings"];
  if (Array.isArray(ayarlar)) {
    nesne["settings"] = ayarlar.filter(
      (a) => !(typeof a === "object" && a !== null && OZETE_GIRMEYEN_AYARLAR.has(String((a as { key?: unknown }).key))),
    );
  }
  const bayt = new TextEncoder().encode(JSON.stringify(nesne));
  const hash = new Uint8Array(await globalThis.crypto.subtle.digest("SHA-256", bayt));
  let hex = "";
  for (const b of hash) hex += b.toString(16).padStart(2, "0");
  return hex;
}
